import SkeletonAvatar from 'antd/lib/skeleton/Avatar';
import SkeletonInput from 'antd/lib/skeleton/Input';
import { v4 as uuid } from 'uuid';
import '../productCard/ProductCard.scss';

const SkeletonProducts = () => {
  const generateItems = () => {
    const items = Array(10).fill('.');
    return items.map(() => {
      return (
        <div className="productCardSkeleton" key={uuid()}>
          <section className="skuSection">
            <SkeletonInput active />
          </section>
          <section className="categorySection">
            <SkeletonInput active />
          </section>
          <section className="photoSection">
            <SkeletonAvatar shape="square" active className="imgLimit" />
          </section>
          <section className="brandSection">
            <SkeletonInput active />
          </section>
          <section className="nameSection">
            <SkeletonInput active />
          </section>
          <section className="characteristicsSection">
            <SkeletonInput active />
          </section>
          <section className="availableCountriesSection">
            <SkeletonInput active />
          </section>
        </div>
      );
    });
  };
  return <>{generateItems()}</>;
};

export default SkeletonProducts;
